// NOTE: this is mobile first design, so the mobile breakpoint is 0, and the tablet breakpoint is 768px, etc. which means the value is the minimum width for that breakpoint.
const breakpoints = {
    mobile: 0,
    tablet: 640,
    desktop: 960,
};
export default Object.freeze(breakpoints);
